import { render, staticRenderFns } from "./CopyTextToClipBoard.vue?vue&type=template&id=7c7c780a&scoped=true&"
import script from "./CopyTextToClipBoard.vue?vue&type=script&lang=js&"
export * from "./CopyTextToClipBoard.vue?vue&type=script&lang=js&"
import style0 from "./CopyTextToClipBoard.vue?vue&type=style&index=0&id=7c7c780a&lang=sass&scoped=true&"
import style1 from "./CopyTextToClipBoard.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c780a",
  null
  
)

export default component.exports